import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useForm, Controller } from "react-hook-form"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import Grid from "@mui/material/Grid"
import { Modal, makeStyles } from "@material-ui/core"
import { squarePayment } from "../v2_actions/square_payment"
import { trolleyProcessPayment } from "../v2_actions/trolley_process_payment"

import { MaterialTextInput } from "../v2_components/form/MaterialTextInput"

const formSchema = yup.object().shape({})

const useStyles = makeStyles({
  modal: {
    position: "relative",
    padding: "20px",
    maxWidth: "500px",
    top: "50%",
    left: "50%",
    background: "white",
    transform: "translate(-50%, -50%)",
  },
  inputContainer: {
    paddingTop: "10px",
  },
  fieldsContainer: {
    paddingBottom: "20px",
  },
  submitButton: {
    color: "#ffffff",
    backgroundColor: "#006aff",
    borderRadius: "5px",
    cursor: "pointer",
    borderStyle: "none",
    userSelect: "none",
    outline: "none",
    fontSize: "16px",
    fontWeight: "500",
    lineHeight: "24px",
    padding: "12px",
    width: "100%",
    boxShadow: "1px",
  },
})

export const SquarePayment = ({
  onClose,
  trolley,
  totalPriceOwingByCustomer,
  onPaymentSuccessfulAndConfirmed,
  onPaymentFailure,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [card, setCard] = useState(null)
  const [loading, setLoading] = useState(false)
  
  const defaultValues = {
    first_name: "",
    last_name: "",
    email_address: "",
    phone_number: "",
  }

  const formProps = useForm({
    resolver: yupResolver(formSchema),
    defaultValues: defaultValues,
  })
  const {
    reset,
    control,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
  } = formProps

  useEffect(() => {
    const initialiseSquare = async () => {
      setLoading(true)
      const squareCard = await squarePayment.getSquareCard(onPaymentFailure)

      setCard(squareCard)
      setLoading(false)
    }
    initialiseSquare()
  }, [])

  const handlePayment = async (values) => {
    if (loading) return
    setLoading(true)
    const token = await squarePayment.getSquareToken(
      card, totalPriceOwingByCustomer
    )
    if (!token) {
      setLoading(false)
      return
    }
    dispatch(squarePayment.createPayment({
      token: token,
      trolley: trolley,
      totalPriceOwingByCustomer: totalPriceOwingByCustomer,
    })).then((res) => {
      if (res.status === 'success') {
        if (res.results.status === 'approved') {
          dispatch(
            trolleyProcessPayment.pay({
              trolley_id: trolley?.id,
              gateway_payment_ref: res.results.reference,
              total_price_paid_by_customer: totalPriceOwingByCustomer,
            })
          ).then((res) => {
            if (res.errors) {
              onPaymentFailure(
                'Failed to verify your payment.'
              )
              setLoading(false)
            } else {
              onPaymentSuccessfulAndConfirmed()
              setLoading(false)
            }
          })
        } else {
          onPaymentFailure(
            'Payment declined by payment provider.'
          )
          setLoading(false)
        }
      } else {
        onPaymentFailure(
          'Payment declined by payment provider.'
        )
        setLoading(false)
      }
    })
  }

  return (
    <Modal
      open={true}
      onClose={onClose}
      disableEnforceFocus
      disableAutoFocus
    >
      <div className="payment-wrapper" class={classes.modal}>
        <form id="payment-form" onSubmit={handleSubmit(handlePayment)}>
          <div id="card-container"></div>
          <button id="card-button" type="submit" disabled={!card || loading} class={classes.submitButton}>
            {loading ? 'Processing…' : `Pay $${totalPriceOwingByCustomer.toFixed(2)}`}
          </button>
        </form>
        <div id="payment-status-container"></div>
      </div>
    </Modal>
  )
}
